module.exports = __webpack_public_path__ + "img/ssb_menu2.a72e9775.png";